/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Nav_DashboardInputs */

const en_layout_nav_dashboard = /** @type {(inputs: Layout_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const pl_layout_nav_dashboard = /** @type {(inputs: Layout_Nav_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulpit`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Layout_Nav_DashboardInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const layout_nav_dashboard = /** @type {((inputs?: Layout_Nav_DashboardInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Nav_DashboardInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_layout_nav_dashboard(inputs)
	return en_layout_nav_dashboard(inputs)
});